import React, { useState } from "react"
import { useMutation } from "urql"

import { Button } from "../../components/shared/Buttons"
import { TextArea } from "../../components/shared/Inputs"
import Typography from "../../components/shared/Typography"
import { useToast } from "../../contexts/ToastContext"
import ReviewProvider from "../../providers/ReviewProvider"

import { ReviewLayout } from "./ReviewLayout"
import VideoReviewModal from "./VideoReviewModal"

const REVIEW_TEXT_REVIEW_MUTATION = `
  mutation ReviewAddTextReview($reviewId: ID!, $text: String!) {
    reviewAddTextReview(reviewId: $reviewId, text: $text) {
      result
      errors
    }
  }
`

const TextReview = ({ review }) => {
  const { showToast } = useToast()
  const [textReview, setTextReview] = useState(review?.review || "")
  const [showVideoModal, setShowVideoModal] = useState(false)
  const [{ fetching }, addTextReview] = useMutation(REVIEW_TEXT_REVIEW_MUTATION)

  const videoReviewsEnabled = review?.videoReviewsEnabled || false

  const handleAddTextReview = () => {
    if (fetching) return

    addTextReview({ reviewId: review.token, text: textReview }).then((res) => {
      if (res.error || !res.data) {
        showToast({ content: "Something went wrong. Please try again.", type: "error" })
        return
      }
      if (res.data.reviewAddTextReview.result === "success") {
        window.location.href = `/i/r/book_next/${review.token}`
      } else {
        showToast({ content: `Error: ${res.data.reviewAddTextReview.errors.join(" ")}`, type: "error" })
      }
    })
  }

  const isFormValid = textReview?.length > 2

  return (
    <ReviewLayout
      percentDone="90%"
      proPic={review.practitioner.filestackPhoto}
      onContinue={handleAddTextReview}
      continueDisabled={!isFormValid || fetching}
      finalStep={true}>
      <Typography variant="h3">
        {review.rating > 3 && "Wonderful!"} Do you want to leave a text or video review now?
      </Typography>
      <Typography variant="subtitle">Share a few words about working with {review.practitioner.firstName}.</Typography>
      <TextArea
        placeholder="Enter your review"
        rows="3"
        className="mt-6"
        onChange={(e) => setTextReview(e.target.value)}
        value={textReview ? textReview : ""}
      />

      {videoReviewsEnabled && (
        <Button className="mt-6 w-full" type="tertiary" onClick={() => setShowVideoModal(true)}>
          I&apos;d rather leave a video review
        </Button>
      )}

      {videoReviewsEnabled && (
        <VideoReviewModal review={review} isOpen={showVideoModal} onClose={() => setShowVideoModal(false)} />
      )}
    </ReviewLayout>
  )
}

export default function ReviewTextReview(props) {
  return (
    <ReviewProvider>
      <TextReview {...props} />
    </ReviewProvider>
  )
}
